// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"ddc83663","482":"26408594"}[chunkId] + ".chunk.css";
};